var map = {
	"./app-store.svg": "b15d",
	"./backdrop.svg": "a2a8",
	"./cost.svg": "ba13",
	"./decoration-1.svg": "537f",
	"./decoration-2.svg": "3912",
	"./decoration-3.svg": "7415",
	"./discount.svg": "54e8",
	"./google-play.svg": "1457",
	"./iconic-content-1.svg": "86e7",
	"./iconic-content-2.svg": "bc49",
	"./iconic-content-3.svg": "d0f1",
	"./information.svg": "d7f9",
	"./leaf3.svg": "1cb8",
	"./leaf4.svg": "e312",
	"./leaf5.svg": "ec7f",
	"./logo-transfr.svg": "ddce",
	"./money.svg": "f7cb",
	"./phone-image-2.svg": "8023",
	"./phone-image.svg": "19d2",
	"./round-leaf.svg": "641a",
	"./shield.svg": "3cb2",
	"./wallet.svg": "bc38"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";